import type {
  GoalRiskLevels,
  GoalTimeHorizons,
  GoalTypes,
} from '@generated/graphql';
import i18n from '../assets/i18n/config';
import type { Account } from './account';
import type { ClientGroup } from './clientGroup';
import type { FinancialProduct } from './financialProduct';
import type { Goal } from './goalSubAccountTypes';
import {
  TRADING_PROCESS_LIST,
  TradingProcessValue,
} from './tradingProcessList';

export type GoalDeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: GoalDeepPartial<T[P]>;
    }
  : T;

export type CreateGoalInput = {
  userId: string;
  riskQuestion1: GoalRiskLevels;
  timeHorizon: GoalTimeHorizons;
  type: GoalTypes;
  financialProductId?: string;
  householdClientGroupId?: string;
  name?: string;
  targetAmountCents?: number;
  taxOptimized?: boolean;
};

export interface DraftGoal extends CreateGoalInput {
  financialProduct?: FinancialProduct;
  householdClientGroup?: ClientGroup;
  accountsLinked?: Account[];
}

export const getGoalName = (goal?: Goal): string => {
  if (goal?.name) return goal.name;
  return goal?.type ? i18n.t(`client:goalType.${goal.type}`) : '';
};

export const GOAL_TRADING_PROCESS_LIST = [
  ...TRADING_PROCESS_LIST.filter((tradingProcess) =>
    [
      TradingProcessValue.NoAutomation,
      TradingProcessValue.PortfolioOptimizer,
    ].includes(tradingProcess.value),
  ),
];
